import { useModal } from "@/Contexts";
import { useGlobalAlert } from "@/States/globalAlert";
import { getInfrastructureUrl } from "@/Utils/getInfrastructureUrl";
import { trpc } from "@/Utils/trpc";
import { useNavigate } from "@/Utils/useNavigate";
import { useSlackNotifications } from "@/api/hooks/useSlackNotifications";
import ModalContainer from "@/components/modalContainer";
import { useMultiSelectContext } from "@/components/pageCards/multiListTable/multiSelectContext";

import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

import { isEmpty } from "lodash";
import { POINT_STATUSES } from "server/coreApi/common/constants.js";

import { StationForm, StationFormData } from "../manage/stationForm";
import { useAccessParentsWithPoints } from "../manage/useAccessParentsWithPoints";

export const AddStationModal: React.FC = () => {
  const { hideModal } = useModal();
  const navigate = useNavigate();

  const { terminalId: urlTerminalId } = useParams();

  const { isLoading: isLoadingAccessParents, refetch } =
    useAccessParentsWithPoints(urlTerminalId);
  const { setSelectedContainers } = useMultiSelectContext();
  const { setGlobalAlert } = useGlobalAlert();

  const { sendNewAccessParentSlackNotification } = useSlackNotifications();

  const formHandler = useForm<StationFormData>({
    defaultValues: { status: POINT_STATUSES[0] },
  });

  const {
    formState: { errors, isValid, isDirty },
    handleSubmit,
  } = formHandler;

  const { mutateAsync, isPending: isSaving } =
    trpc.accessParents.create.useMutation({
      onSuccess: async (modifiedPoint) => {
        await refetch();
        setGlobalAlert({
          type: "success",
          message: "systemMessages:accessParentAdded",
        });
        sendNewAccessParentSlackNotification(
          modifiedPoint.name,
          modifiedPoint.id,
        );
        setSelectedContainers([]);

        const url = getInfrastructureUrl({
          terminalId: urlTerminalId,
          accessParentId: modifiedPoint.id,
        });
        navigate(url);
        hideModal();
      },
      onError: (error) => {
        setGlobalAlert({
          type: "error",
          message: "errors:failedSave",
          instructions: error.message,
        });
      },
    });

  const isLoading = isLoadingAccessParents || isSaving;

  const onSubmit = handleSubmit(
    (formData: {
      name: string;
      status: string;
      coordinates: string;
      municipality: string;
      client: string;
    }) => {
      const { name, status, coordinates, municipality, client } = formData;

      mutateAsync({
        name,
        status,
        coordinates,
        municipality,
        clientName: client,
        parentId: urlTerminalId!,
      });
    },
  );

  return (
    <ModalContainer
      title="actions:newAccessParent"
      onConfirmText={"actions:confirm"}
      onConfirm={() => onSubmit()}
      onCancel={hideModal}
      onConfirmLoading={isLoading}
      onConfirmDisabled={!isEmpty(errors) || !isValid || isSaving}
      className="w-3/4 sm:w-1/2 lg:w-1/3"
      showDiscardModal={isDirty}
    >
      <StationForm {...{ formHandler, onSubmit }} />
    </ModalContainer>
  );
};
